
export default {
  name: 'CustomInput',
  props: {
    optional: {
      type: Boolean, 
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 256
    },
    rules: {
      type: String,
      default: ''
    },
    labelDescription: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      default: ''
    }
  },
  computed: {
    name() {
      return this.label.toLowerCase();
    }
  },

  methods: {}
};
